import { useContext, useEffect, useState } from "react";
import TitlePage from "../../components/titlePage/titlePage";
import SwalAlert from "../../utils/swalAlert";
import styles from "./bienestar.module.css";
import Loading from "../../components/loading/loading";
import ApiFetch from "../../utils/fetch";
import { AppContext } from "../../context/context";
import ServiciosSociales from "../../components/ServiciosSociales";
import { Alert } from "@mui/material";
import ReturnBackButton from "../../components/returnBackButton/ReturnBackButton";

const alert = new SwalAlert();
const fetch = new ApiFetch();

export default function Bienestar() {
  const { sessionExpired } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [servicios, setServicios] = useState(null);

  //Buscar servicios sociales del cliente.
  async function getServiciosSociales() {
    try {
      setLoading(true);
      const data = await fetch.GET("/cliente/servicios-sociales");
      const status = data?.status;
      const message = data?.message;

      if (status === 401) {
        sessionExpired(message);
        return;
      }

      if (status !== 200) {
        // Si no hay datos, usamos los de prueba para desarrollo
        setServicios(null);
        return;
      }

      setServicios(data?.body);
    } catch (error) {
      alert.error(
        "No fue posible consultar los servicios sociales, intente nuevamente más tarde.",
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getServiciosSociales();
  }, []);

  return (
    <div className={styles.container}>
      <ReturnBackButton />
      <TitlePage idTramite={10} />

      <Alert severity="info">
        Para consultas o actualizaciones dirigirse a sede central y sacar turno
        en RED BIENESTAR COOPERATIVO.
      </Alert>

      {loading && <Loading />}
      {!loading && servicios ? (
        <ServiciosSociales servicios={servicios} />
      ) : (
        <Alert severity="warning">
          No tienes servicios sociales adheridos.
        </Alert>
      )}
    </div>
  );
}
